import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { JoinTransformation } from 'app/model/dataflow/jointransformation';
import { BaseMultiInputStreamTransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-multi-input-stream-transformation.adapter';
import { DataFlowExpressionUtils } from '../expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JoinTransformation),
    asynchronous: true
})
export class JoinTransformationAdapter extends BaseMultiInputStreamTransformationAdapter {
    protected getExpressionScript(transformation: JoinTransformation): string {
        if (transformation.matchType === 'fuzzy') {
            const fuzzyExpressionList = transformation.conditionExpressions.map((expression) => {
                return (
                    `fuzzyCompare(${DataFlowExpressionUtils.wrapExpressionWithEmptyValue(
                        expression.leftExpression.expression
                    )},` +
                    ` ${DataFlowExpressionUtils.wrapExpressionWithEmptyValue(
                        expression.rightExpression.expression
                    )}, ` +
                    `${expression.overrideSimilarityThreshold.toFixed(2)})`
                );
            });
            let fuzzyExpression = fuzzyExpressionList.join(',\n\t');
            fuzzyExpression += `${fuzzyExpression ? ',\n\t' : ''}joinType:\'${
                transformation.joinType
            }\',\n\tmatchType:\'${transformation.matchType}\',\n\tignoreSpaces: ${transformation.ignoreSpaces}`;
            if (transformation.scoreColumn) {
                fuzzyExpression += `${fuzzyExpression ? ',\n\t' : ''}scoreColumn:\'${transformation.scoreColumn}\'`;
            }
            return fuzzyExpression;
        } else {
            let expressionScript =
                transformation.joinType === 'cross' && 'crossExpression' in transformation
                    ? DataFlowExpressionUtils.wrapExpressionWithEmptyValue(transformation.crossExpression.expression)
                    : super.getExpressionScript(transformation);
            expressionScript += `${expressionScript ? ',\n\t' : ''}joinType:\'${
                transformation.joinType
            }\',\n\tmatchType:\'${transformation.matchType}\',\n\tignoreSpaces: false`;
            return expressionScript;
        }
    }
}
